import React, { useContext }  from 'react'
import ResinousSystem from './ResinousSystem'
import { AppContext } from '../../../App'
import ProductsNotFound from '../../productsNotFound'
import Loading from '../../loading'

export default function ResinousSystemList() {
   const {
      resinousFloorSystems,
      resinousWallSystems,
      resinousCoveSystems,
      productOptionsSelected,
      loading
   } = useContext(AppContext)
   
   const { productOptions } = productOptionsSelected
   const productDetail = "resinous systems"

   let selectedSystems
   switch(productOptions[2]) {
      case "Floor": selectedSystems = resinousFloorSystems; break
      case "Wall": selectedSystems = resinousWallSystems; break
      case "Cove": selectedSystems = resinousCoveSystems; break
      default: alert("No resinous system found.")
   }

   return loading ? (
      // If loading, show loader.
      <Loading type="resinous systems" />
   ) : (
      // If not loading, check to see there is at least one selectedSystems. If so, render list. If not, render ProductsNotFound component.
      selectedSystems.length > 0 ? (
         <div className="panel panel-primary list-items">
               <div className="panel-heading">
                  <h4 className="panel-title">Select a { productOptions[2] } System</h4>
               </div>
               <div className="panel-body">
               { selectedSystems.map((s, index) => {
                  return (
                     <ResinousSystem key={ s.id + "-" + s.name } productIndex={ index } { ...s } />
                  )
               })}
               </div>
         </div>
      ) : (
      // If there are no resinous systems found, render placeholder apology.
      <ProductsNotFound productDetail={ productDetail } />    
      )
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystemList.js